/* Créé par Incipit Studio — Ajout au panier */
if (!customElements.get('kaarz-collection-cards')) {
  customElements.define('kaarz-collection-cards', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-kcl-form]')) return;
        event.preventDefault();
        this.add(event.target);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async add(form) {
      const button = form.querySelector('[data-kcl-submit]');
      if (button.disabled) return;
      const label = button.querySelector('span');
      const original = label.textContent;
      const card = form.closest('.kcl-card');
      const error = card.querySelector('.kcl-error');
      const status = this.querySelector('.kcl-status');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'AJOUT EN COURS…';
      error.hidden = true;
      card.classList.remove('has-error');
      status.textContent = '';
      let added = false;
      try {
        const body = new FormData(form);
        if (cart?.getSectionsToRender) {
          body.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
          body.set('sections_url', location.pathname);
          cart.setActiveElement?.(button);
        }
        const url = this.dataset.addUrl.endsWith('.js') ? this.dataset.addUrl : `${this.dataset.addUrl}.js`;
        const response = await fetch(url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
        const data = await response.json();
        if (!response.ok || data.status) {
          const message = typeof data.description === 'string' ? data.description : 'Ce produit ne peut pas être ajouté pour le moment.';
          throw new Error(message);
        }
        added = true;
        status.textContent = 'Produit ajouté au panier.';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kaarz-collection-cards', productVariantId: body.get('id'), cartData: data })).catch(() => {});
        }
        const sections = cart?.getSectionsToRender?.() || [];
        const complete = sections.length && sections.every(section => typeof data.sections?.[section.id] === 'string');
        if (cart?.renderContents && cart.isConnected && complete) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          location.assign(this.dataset.cartUrl);
        }
      } catch (failure) {
        if (added) {
          location.assign(this.dataset.cartUrl);
        } else {
          error.textContent = failure instanceof TypeError || failure instanceof SyntaxError
            ? 'Ajout non confirmé. Vérifiez votre panier avant de réessayer.'
            : failure.message;
          error.hidden = false;
          card.classList.add('has-error');
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = original;
      }
    }
  });
}
